import { Component, Input, OnInit } from '@angular/core';
import { ContentService } from '../../_core';
import { Entry } from 'contentful';

// import { faBars } from '@fortawesome/free-solid-svg-icons';



@Component({
  selector: 'lcp-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Input('isInverted') isInverted: boolean = false

  navItems: any

  // faBars = faBars

  shouldShowMenu: boolean = false

  constructor(
    public contentService: ContentService
  ) { }

  ngOnInit() {
    this.getMainNavItems()
  }

  getMainNavItems() {
    this.contentService.getMainNavItems()
    .subscribe({
      next: (navItems) => {
        let results = navItems.items
        this.navItems = results[0].fields['items']
        // console.log('navItems:', this.navItems)
      }
   })
  }

  toggleMobileMenu() {
    this.shouldShowMenu = !this.shouldShowMenu
    // nav.classList.toggle("nav-active");
  }


  
}
